import React, { useEffect, useState } from "react";
import "@Styles/mandate.css";
import staticProfile from "@Images/NewUI/staticimg.png";
import email_view from "@Images/NewUI/email_view.png";
import smartphone_view from "@Images/NewUI/smartphone_view.png";
import ekycbtn from "@Images/NewUI/editbutton.png";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  resendOtp,
  verifyOtpPhone
} from "../../../Redux/Authenticate/action";
import { profilePicture } from "../../../Redux/ApplyLoan/action";
import ToastMsg from "../../../helper/ToastMsg";
import arrowleftnew from "@Images/NewUI/Vectorleft.png";

const ProfileView = (props) => {
  const navigate = useNavigate();
  // console.log("profile_Picture_data", props);
  let token = props?.user?.manual_token;
  let profileData = props.userDetail.user_detail?.customusermodel;
  const [profilePicture, setProfilePicture] = useState();

  const generateOtpVerifyLink = (phone_number) => {
    
    props
    .resendOtp({
      phone_number,
    })
    .then((res) => {
      navigate(`/existingverifyOtpmoble?phone_number=${phone_number}`);
      
    })
    .catch((err) => {
      setLoader(false);
      if (err.response?.status === 401) {
        window.location.href = "/";
        localStorage.removeItem("gpay_token");
      }
      let error = err?.response?.data?.error;
      ToastMsg(error, "error");
      // console.log(err);
    });

  };

  useEffect(() => {
    handleprofilePicture();
  }, []);
  /* istanbul ignore next */
  const handleprofilePicture = () => {
    props
      .profilePicture("", token)
      .then((res) => {
        setProfilePicture(res?.data?.presigned_url);
        // console.table("response loan history", res);
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
         window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };
// console.log("hii i'm consol, just hit")
  return (
    <div id="background" className="main_div">
      <div className="container">
        <div className="pb-4">
          <div className="profile_upper_info text-center  toolbarRespo">
            <img
            style={{marginTop:50}}
              src={profilePicture || staticProfile}
              className="staticProfile"
              alt="profile"
            />
            <div className=" p_view">
              <p className="user_p_name">{profileData?.first_name_show}</p>
              <div className="text-left">
                <span className="user_email flex-i prof_vie_pd align-center">
                  <img className="width-38" src={email_view} alt="email" />
                  <div className="l_v_info">
                    <span className="profileMenuColour">Email</span>
                    <p className="profileMenuColour">{props?.userDetail?.user_detail?.email}</p>
                  </div>
                </span>
                <span className="user_no flex-i prof_vie_pd align-center">
                  <img  src={smartphone_view} className="smartphoneview width-38" alt="smartphone" />
                  <div className="l_v_info">
                    <span className="profileMenuColour">Mobile Number</span>
                    <p className="profileMenuColour">{profileData?.phone_number}</p>
                    <a onClick={() => generateOtpVerifyLink(profileData?.phone_number)}>
                       <img src={ekycbtn} style={{width:61, height:28}} className="profile_edit_btn" alt="policy" />
                    </a>
                  </div>
                </span>
              </div>
              <span className="headingprofile_menu">
              <img className="arrowbtnpaddingnew" style={{cursor:"pointer"}}  src={arrowleftnew}  onClick={() => {
                window.location.href="/profile_menu"
        
      }} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    userDetail: state.userDetail,
  };
};


export default connect(mapStateToProps, { profilePicture , resendOtp,
  verifyOtpPhone})(ProfileView);
